import React, { Component } from 'react'
import './Mag.css';

import img1 from '../assets/issue_5/5_1.png'
import img2 from '../assets/issue_5/5_2.png'
import img3 from '../assets/issue_5/5_3.png'
import img4 from '../assets/issue_5/5_4.png'
import img5 from '../assets/issue_5/5_5.png'
import img6 from '../assets/issue_5/5_6.png'
import img7 from '../assets/issue_5/5_7.png'
import img8 from '../assets/issue_5/5_8.png'
import img9 from '../assets/issue_5/5_9.png'
import img10 from '../assets/issue_5/5_10.png'
import img11 from '../assets/issue_5/5_11.png'
import img12 from '../assets/issue_5/5_12.png'
import img13 from '../assets/issue_5/5_13.png'
import img14 from '../assets/issue_5/5_14.png'
import img15 from '../assets/issue_5/5_15.png'
import img16 from '../assets/issue_5/5_16.png'
import img17 from '../assets/issue_5/5_17.png'
import img18 from '../assets/issue_5/5_18.png'
import img19 from '../assets/issue_5/5_19.png'

export default class Mag005 extends Component {
  render() {
    return (
      <div className="image-container">
        <img src={img1} className="image"></img>
        <img src={img2} className="image"></img>
        <img src={img3} className="image"></img>
        <img src={img4} className="image"></img>
        <img src={img5} className="image"></img>
        <img src={img6} className="image"></img>
        <img src={img7} className="image"></img>
        <img src={img8} className="image"></img>
        <img src={img9} className="image"></img>
        <img src={img10} className="image"></img>
        <img src={img11} className="image"></img>
        <img src={img12} className="image"></img>
        <img src={img13} className="image"></img>
        <img src={img14} className="image"></img>
        <img src={img15} className="image"></img>
        <img src={img16} className="image"></img>
        <img src={img17} className="image"></img>
        <img src={img18} className="image"></img>
        <img src={img19} className="image"></img>
      </div>
    )
  }
}
